interface StoryCreditSectionProps {
  remainingStories?: number;
}

const StoryCreditSection = ({remainingStories}: StoryCreditSectionProps) => (
  <section className="flex flex-col border-[1px] rounded border-green-500 text-gray-900 p-3 bg-[#F8FFFC] mt-4">
    <i className="icon-nameCheck-circle text-xxl text-green-500 mb-2" />
    <span className="font-Medium">اعتبار شما برای ثبت استوری:</span>
    <span className="font-Medium">
      {remainingStories ?? 0} استوری تا آخر ماه
    </span>
  </section>
);

export default StoryCreditSection;
